import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';

export function IsUpdatedColumn({
  info,
}: ColumnComponentProps<BackofficeActivitiesOrderItem, boolean | undefined>) {
  return (
    <Text
      fontSize="sm"
      fontWeight="400"
      color="#373F41"
      w="full"
      lineHeight="short"
      textAlign="center"
    >
      {info.getValue() === true
        ? `${info.row.original.update_origin === 'admin' ? 'Admin' : 'SAP'}`
        : '-'}
    </Text>
  );
}
